<template>
  <v-bottom-navigation :value="activeItem" app grow class="mobile-navigation" aria-label="App navigation">
    <v-btn v-for="item in items" :key="item.value" :value="item.value" :to="item.path">
      <span>{{ item.title }}</span>
      <v-icon>{{ item.icon }}</v-icon>
    </v-btn>
    <v-btn value="more" aria-haspopup="dialog" @click="moreOpen = true">
      <span>More</span>
      <v-icon>mdi-dots-horizontal-circle-outline</v-icon>
    </v-btn>

    <v-bottom-sheet v-model="moreOpen" inset content-class="mobile-more-sheet">
      <v-card class="rounded-t-xl">
        <v-card-title class="mobile-more-sheet__header">
          <span>More</span>
          <v-btn icon aria-label="Close more menu" @click="moreOpen = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="mobile-more-sheet__body">
          <v-list nav color="transparent">
            <v-list-item to="/employee/list" @click="moreOpen = false">
              <v-list-item-icon><v-icon color="primary">mdi-account-group-outline</v-icon></v-list-item-icon>
              <v-list-item-content><v-list-item-title>Employees</v-list-item-title><v-list-item-subtitle>Manage employees and roles</v-list-item-subtitle></v-list-item-content>
              <v-list-item-icon><v-icon>mdi-chevron-right</v-icon></v-list-item-icon>
            </v-list-item>
            <v-list-item to="/settings" @click="moreOpen = false">
              <v-list-item-icon><v-icon color="primary">mdi-cog-outline</v-icon></v-list-item-icon>
              <v-list-item-content><v-list-item-title>Settings</v-list-item-title><v-list-item-subtitle>Account and business settings</v-list-item-subtitle></v-list-item-content>
              <v-list-item-icon><v-icon>mdi-chevron-right</v-icon></v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </v-bottom-navigation>
</template>

<script>
export default {
  name: "MobileNavigation",
  props: { currentPath: { type: String, default: "" } },
  data: () => ({
    moreOpen: false,
    items: [
      { title: "Overview", icon: "mdi-home-outline", path: "/home", value: "home" },
      { title: "Locations", icon: "mdi-store-outline", path: "/location", value: "location" },
      { title: "Notifications", icon: "mdi-bell-outline", path: "/notifications", value: "notifications" },
    ],
  }),
  computed: {
    activeItem() {
      const path = this.currentPath || this.$route.path;
      if (path.startsWith("/location")) return "location";
      if (path.startsWith("/notifications")) return "notifications";
      if (path.startsWith("/employee") || path.startsWith("/settings")) return "more";
      if (path === "/" || path === "/home") return "home";
      return null;
    },
  },
};
</script>

<style scoped>
.mobile-navigation {
  padding-bottom: env(safe-area-inset-bottom);
  height: calc(56px + env(safe-area-inset-bottom)) !important;
  position: fixed !important;
  bottom: 0 !important;
  left: 0;
  right: 0;
  z-index: 20;
}
.mobile-navigation .v-btn { color: rgba(0, 0, 0, 0.62) !important; min-width: 0 !important; }
.mobile-navigation .v-btn.v-btn--active { background: var(--brand-primary) !important; color: #fff !important; }
.theme--dark .mobile-navigation .v-btn { color: rgba(255, 255, 255, 0.72) !important; }
.theme--dark .mobile-navigation .v-btn.v-btn--active { color: #fff !important; }
.mobile-navigation .v-btn::before { opacity: 0 !important; }
.mobile-more-sheet__header { align-items: center; border-bottom: 1px solid rgba(0, 0, 0, 0.12); justify-content: space-between; }
.mobile-more-sheet__body { padding: 8px 12px calc(12px + env(safe-area-inset-bottom)); }
.mobile-more-sheet__body .v-list-item { min-height: 64px; }
</style>

<style>
.mobile-more-sheet { margin: 0 !important; max-width: 640px; }
.mobile-more-sheet .mobile-more-sheet__header { align-items: center; border-bottom: 1px solid rgba(0, 0, 0, 0.12); justify-content: space-between; }
.theme--dark .mobile-more-sheet .mobile-more-sheet__header { border-bottom-color: rgba(255, 255, 255, 0.16); }
.mobile-more-sheet .mobile-more-sheet__body { padding: 8px 12px calc(12px + env(safe-area-inset-bottom)); }
.mobile-more-sheet .mobile-more-sheet__body .v-list-item { min-height: 64px; }
</style>
